<div class="d-flex align-items-center item">
  {{ logType.name }}
</div>
